export const certificationsData = {
  titleTag: "Certifications",
  heading: "Certified Quality. Trusted Manufacturing.",
  description:
    "Our certifications and industry credentials demonstrate our commitment to quality, technical expertise, and globally recognized manufacturing practices. They reflect the standards we follow to deliver reliable wiring harness solutions for diverse industries.",

  items: [
    {
      id: 1,
      title: "ISO 9001:2015",
      badge: "Quality Certified",
      description:
        "Certified Quality Management System ensuring standardized manufacturing processes, continual improvement, and consistent product quality across every stage of engineering and production.",
      image: "/images/certificate1.png",
      altText: "ISO 9001:2015 Quality Management Certificate",
      features: [
        "Quality Management",
        "Process Consistency",
        "Continuous Improvement"
      ],
      link: "#",
      reverse: false
    },

    {
      id: 2,
      title: "IPC/WHMA-A-620 Certified",
      badge: "Industry Certified",
      description:
        "Our IPC certification reflects expertise in the industry's leading standard for cable and wire harness assemblies, ensuring workmanship, reliability, and manufacturing practices that meet globally accepted quality requirements.",
      image: "/images/certificate2.png",
      altText: "IPC/WHMA-A-620 Certified IPC Trainer Certificate",
      features: [
        "IPC Standards",
        "Harness Workmanship",
        "Global Best Practices"
      ],
      link: "#",
      reverse: true
    },

    {
      id: 3,
      title: "Importer Exporter Code (IEC)",
      badge: "Government Approved",
      description:
        "Registered with the Directorate General of Foreign Trade (DGFT), enabling international business operations and supporting reliable supply to customers across global markets.",
      image: "/images/certificate3.png",
      altText: "Importer Exporter Code Registration Certificate",
      features: [
        "DGFT Registered",
        "Global Trade",
        "Export Ready"
      ],
      link: "#",
      reverse: false
    }
  ]
};